'use strict';

/** Make connection between two or more elements
 *
 * 1. Include '.connector' class on html elements that you want to be trigger the connected elements
 * (a*)
 *
 * 2. Include 'data-connector="connector"' attribute on all HTML elements that will be connected together
 * (a*)
 *
 * a* .You can change the default name to another eg. '.menu-connector'.
 *    .It is preferred if Connector plugin calls more than once.
 *
 * @param options
 *
 * founder: this,              // The initial items, must be wrap all of the connectors
 * connector: '.connector',    // The trigger
 * removeSiblings: false,      // If siblings exist, remove 'active' class from them,
 * triggerType:                // You can choose between 'click' and 'mouseover'. The other events are not tested.
 * toggleClassName: 'active'   // You can add your className.
 *
 */
$.fn.connector = function (options) {

    const opt = $.extend({
        founder: this,
        connector: '.connector',
        removeSiblings: false,
        triggerType: 'click',
        toggleClassName: 'active',
        atLeastOneEnabled: false,
        breakpoint: true,
        page: true,
    }, options);

    const app = {

        init: () => {

            // Check if meets the page and the breakpoint
            if ( opt.page && opt.breakpoint && opt.founder.length ) {
                app.action();
            }

        },

        action: () => {

            // opt.founder.each((i, el) => {

            opt.connector = opt.founder.find(opt.connector);

            // If connector exists
            if ( opt.connector ) {

                // On triggerType (use click or mouse over)
                opt.connector.on( opt.triggerType, (e) => {

                    app.activate(e.currentTarget);

                    const href = $(e.currentTarget).attr('href');

                    // Prevent from moving to top if the current attribute is #
                    if ( href === '#' ) {
                        e.preventDefault();
                    }

                });
            }

            // });

        },

        activate: (target) => {

            // Get the connector data attribute
            const data_connector = $(target).data('connector');

            // If removeSiblings is activated
            if ( opt.removeSiblings ) {

                // Remove siblings of each item and all it relatives
                opt.founder.find('[data-connector=' + data_connector + ']').siblings().removeClass(opt.toggleClassName);

            }

            // On data-connectors with certain name, toggle-class
            opt.founder.find('[data-connector=' + data_connector + ']').toggleClass( opt.toggleClassName );

        },
    };

    app.init();

};